import { render, staticRenderFns } from "./NewsCategoryOrTag.vue?vue&type=template&id=4ad1be98&scoped=true&"
import script from "./NewsCategoryOrTag.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryOrTag.vue?vue&type=script&lang=js&"
import style0 from "./NewsCategoryOrTag.vue?vue&type=style&index=0&id=4ad1be98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad1be98",
  null
  
)

export default component.exports